import { useQuery } from '@tanstack/react-query';
import { endpoints } from '@rossum/api-client';
import { useApiClient } from '../../lib/apiClient';

export const QUERY_KEY_USER = 'user';

export const useGetUser = ({ userId }: { userId: string }) => {
  const api = useApiClient();
  return useQuery({
    queryKey: [QUERY_KEY_USER, userId] as const,
    queryFn: () => api.request(endpoints.users.get(userId)),
  });
};
